import script from "./MainScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainScreen.vue?vue&type=script&setup=true&lang=ts"

import "./MainScreen.vue?vue&type=style&index=0&id=467d64c3&lang=scss"

const __exports__ = script;

export default __exports__